import React from "react";
import I18n from "../../../../commons/I18n/I18n";
import DeltaCar from "../../../../commons/model/DeltaCar";
import { generateRoute } from "../../../../commons/utils/Router";
import Th from "../../../../components/table/Th";
import I18nKeys from "../../../../I18n/I18nKeys";
import { ROUTE_COMPANY_USER_DELTA_CAR_DETAIL } from "../../../../routing/Routes";
import { goToRoute } from "../../../../utils/Router";
import { OnSortHandler, SortState } from "../../../../utils/Sort";

interface DeltaCarListTableProps {
    data: DeltaCar[];
    error: string;
    onSort: OnSortHandler;
    sort: SortState;
    renderSelectTd?: (itemId: string)=> React.ReactNode;
}

const goToItemDetail = (itemId: string): void => {
  goToRoute(generateRoute(ROUTE_COMPANY_USER_DELTA_CAR_DETAIL, {
    id: itemId,
  } ));
};

export default class DeltaCarListTable extends React.Component<DeltaCarListTableProps> {
  public render(): React.ReactNode {
    const {data, renderSelectTd} = this.props;

    return (
      <table className="table table-hover">
        <thead>{this.renderTH()}</thead>
        <tfoot>{this.renderTH()}</tfoot>
        <tbody>
          {data && data.map((deltaCar: DeltaCar) => (
            <tr key={deltaCar.id}
              onClick={() => goToItemDetail(deltaCar.id)}
              className={"tr-cursor"}
            >
              {renderSelectTd ? renderSelectTd(deltaCar.id) : null}
              <td>
                {deltaCar.name}
              </td>
              <td>{deltaCar.license_plate}</td>
            </tr>
          ))}
        </tbody>
      </table>
    );
  }

  private renderTH(): React.ReactNode {
    const {sort, children, onSort} = this.props;
    const commonProps = {
      sort,
      onSort,
    };

    return (
      <tr>
        {children}
        <Th text={I18n.tr(I18nKeys.NOMBRE)}
          columnName={"name"}
          {...commonProps}
        />
        <Th text={I18n.tr(I18nKeys.MATRICULA)}
          columnName={"license_plate"}
          {...commonProps}
        />
      </tr>
    );
  }
}
